import styles from './styles.module.css'

export type AppLogoStatus = 'success' | 'error' | undefined

export function AppLogo({ logoUrl, status }: { logoUrl?: string; status?: AppLogoStatus }) {
  return (
    <div className={styles.container}>
      <img src={logoUrl ?? '/reown-logo.webp'} alt="App Logo" className={styles.logo} />
      {status === 'success' && <wui-icon-box size="sm" color="success" icon="checkmark" />}
      {status === 'error' && <wui-icon-box size="sm" color="error" icon="warningCircle" />}
    </div>
  )
}
